import React from 'react';
import {Card, Form} from 'semantic-ui-react';
import SearchFloatingClient from './searchFields/searchFloatingClient';
import SearchFloatingInventory from './searchFields/searchFloatingInventory';
import './styles.scss';

export const InventorySearchCard = ({
  currentScreen,
  floatingClientList,
  floatingInventoryList,
  resetAllFilters,
  showFilters,
  setResetAllFilters,
  setShowFilters,
}) => {
  return (
    <Card fluid>
      <Form size={'small'}>
        {currentScreen === 'FL_INV' ? (
          <SearchFloatingInventory
            resetAllFilters={resetAllFilters}
            showFilters={showFilters}
            setResetAllFilters={setResetAllFilters}
            setShowFilters={setShowFilters}
            floatingInventoryList={floatingInventoryList}
          />
        ) : (
          <SearchFloatingClient
            resetAllFilters={resetAllFilters}
            showFilters={showFilters}
            setResetAllFilters={setResetAllFilters}
            setShowFilters={setShowFilters}
            floatingClientList={floatingClientList}
          />
        )}
      </Form>
    </Card>
  );
};
